export default __webpack_public_path__ + "static/media/category4.7291d6e0.svg";